/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _2_DaysInputs */

const en__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 days before`)
};

const ar__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبل يومين`)
};

const de__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 Tage vorher`)
};

const es__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 días antes`)
};

const fr__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 jours avant`)
};

const it__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 giorni prima`)
};

const ja__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2日前`)
};

const ko__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2일 전`)
};

const pt_br__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 dias antes`)
};

const ru__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За 2 дня`)
};

const th__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล่วงหน้า 2 วัน`)
};

const tr__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 gün önce`)
};

const zh_cn__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提前 2 天`)
};

const zh_tw__2_days = /** @type {(inputs: _2_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提前 2 天`)
};

/**
* | output |
* | --- |
* | "2 days before" |
*
* @param {_2_DaysInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const _2_days = /** @type {((inputs?: _2_DaysInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_2_DaysInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__2_days(inputs)
	if (locale === "ar") return ar__2_days(inputs)
	if (locale === "de") return de__2_days(inputs)
	if (locale === "es") return es__2_days(inputs)
	if (locale === "fr") return fr__2_days(inputs)
	if (locale === "it") return it__2_days(inputs)
	if (locale === "ja") return ja__2_days(inputs)
	if (locale === "ko") return ko__2_days(inputs)
	if (locale === "pt_br") return pt_br__2_days(inputs)
	if (locale === "ru") return ru__2_days(inputs)
	if (locale === "th") return th__2_days(inputs)
	if (locale === "tr") return tr__2_days(inputs)
	if (locale === "zh_cn") return zh_cn__2_days(inputs)
	return zh_tw__2_days(inputs)
});
export { _2_days as "2_days" }